import { aiEmployeesHub } from "./categories.ts";

/** Public pages that moved to a new address; each also covers its `.md` export. */
const renamedPaths: Record<string, string> = {
  "/compare/best-ai-teammates": aiEmployeesHub.path,
  "/compare/best-ai-teammates-2026": "/blog/best-ai-employees-2026",
  "/blog/best-ai-teammates-2026": "/blog/best-ai-employees-2026",
  "/blog/maito-and-alternatives-for-customer-work-and-coding": "/blog/devin-alternatives",
};

export function legacyChangelogPath(pathname: string) {
  return pathname === "/release-notes" || pathname.startsWith("/release-notes/")
    ? pathname.replace("/release-notes", "/changelog")
    : null;
}

export function publicRedirectPath(pathname: string) {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  const legacy = legacyChangelogPath(path);
  if (legacy) return legacy;
  const markdown = path.endsWith(".md") ? ".md" : "";
  const renamed = renamedPaths[markdown ? path.slice(0, -3) : path];
  if (renamed) return renamed + markdown;
  const comparison = /^\/compare\/([a-z0-9-]+)(\.md)?$/.exec(path);
  if (comparison && path.replace(/\.md$/, "") !== aiEmployeesHub.path)
    return `/blog/${comparison[1]}${comparison[2] ?? ""}`;
  if (path === "/terms-of-service") return "/terms";
  if (path === "/privacy-policy") return "/privacy";
  return path !== pathname ? path : null;
}
